import { createContext } from "react";

export const ToastState = createContext();
ToastState.displayName = "ToastState";
